<i {...$$props} class:notranslate={true} translate={false}><slot></slot></i>